import React, {useEffect} from "react";
import Api from "./services/Api";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getCbLoginCookieValue, isValidUrl} from "./utility/IamLoginUtils";

const Logout = () => {
    //const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    //const [loading, setLoading] = React.useState(true);
    //const [destinationPage, setDestinationPage] = React.useState(null);

    useEffect(() => {
        async function handleLogout() {
            let DURL = searchParams.get("DURL");
            let appId = searchParams.get("appId");

            let logOutRequest = {
                unifiedSessionId: getCbLoginCookieValue(),
                appId: (!appId || isNaN(appId)) ? 466 : Number(appId),
            };

            if (DURL && isValidUrl(DURL)) {
                logOutRequest.destinationUrl = DURL;
            }

            console.log("logOutRequest", logOutRequest);
            // CB terminate session
            let result = await Api.logout(logOutRequest);
            let destinationPage = result.destinationUrl;

            if (!destinationPage) {
                destinationPage = "https://www.collegeboard.org";
            }
            console.log(destinationPage);

            // Remove the session storage all items
            sessionStorage.clear();
            // Remove cookies
            document.cookie =
                "cb_login=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";
            document.cookie =
                "iamkiwilog=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";
            document.cookie =
                "cb_tree_env=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";

            if (window.appConfig.envName !== "prod") {
                document.cookie =
                    "lower_Env=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";
            }

            // Delete all Okta sessions
            try {
                await Api.deleteAllOktaSessions(false);
            } catch (error) {
                console.error("Error occurred when deleting Okta sessions!");
            }
            // Navigate to destinationPage
            window.location = destinationPage;
        }

        handleLogout();
    }, []);
    /* return (
      <div className="logout">
      {  <h1>Logout</h1>
        destinationPage ? (
          <p className="testLogout">
            Debug Info only logout, redirect to {destinationPage}{" "}
          </p>
        ) : (
          <div>No Destination Page</div>
        )}
      </div>
    ); */
    return null;
};

export default Logout;
